import { Box, BoxProps } from "@chakra-ui/react";
import { Account, Activity } from "common";
import { get12HrTime } from "../utils/time";
import { useMemo } from "react";
import { Avatar } from "../avatar/Avatar";

interface ActivityCardProps extends BoxProps {
  activity: Activity;
  accounts: Account[];
}

export const ActivityCard = ({
  activity,
  accounts,
  ...props
}: ActivityCardProps) => {
  const involvedAccounts = useMemo(
    () =>
      accounts.filter((a) =>
        activity.description.includes(
          `**@${a.fName.replaceAll(" ", "")}${a.lName.replaceAll(" ", "")}**`
        )
      ),
    [accounts, activity.description]
  );

  const showAvatar = useMemo(
    () => involvedAccounts.length <= 3,
    [involvedAccounts.length]
  );

  return (
    <Box
      background={activity.background}
      boxShadow={
        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
      }
      borderRadius={"0.5rem"}
      padding={"0.25rem"}
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      flexWrap={"wrap"}
      color={activity.textColor}
      {...props}
    >
      <Box fontWeight={"bold"} fontSize={"1rem"} textAlign={"center"}>
        {activity.title}
      </Box>
      <Box opacity={"0.6"} fontWeight={"bold"}>{`${get12HrTime(
        activity.startTime
      )} - ${get12HrTime(activity.endTime)}`}</Box>
      {activity.endTime - activity.startTime >= 60 * 60 * 1000 ? (
        <Box
          width={"100%"}
          display={"flex"}
          justifyContent={"center"}
          paddingLeft={2}
          paddingRight={2}
          alignItems={"center"}
        >
          {involvedAccounts.map((account, i) => (
            <Box
              key={account.id}
              display={"flex"}
              alignItems={"center"}
              backgroundColor={"#ffffff"}
              borderRadius={"25px"}
              height={"25px"}
              paddingLeft={"2px"}
              paddingRight={showAvatar ? "22.5px" : "7px"}
              marginTop={1}
              marginBottom={1}
              fontSize={"small"}
              boxShadow={"base"}
              marginLeft={i !== 0 ? 1 : undefined}
              maxW={
                involvedAccounts.length > 0
                  ? `${100 / involvedAccounts.length}%`
                  : undefined
              }
            >
              {showAvatar ? (
                <Avatar
                  config={account.avatarConfig}
                  round={true}
                  width={"20px"}
                  height={"20px"}
                />
              ) : null}
              <Box
                fontWeight={"bold"}
                color={"teal"}
                marginLeft={1}
                overflow={"hidden"}
                whiteSpace={"nowrap"}
                textOverflow={"ellipsis"}
              >
                @{account.fName}
                {involvedAccounts.length <= 2 ? " " + account.lName : ""}
              </Box>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
};
